import { util, EventBus } from 'pevueglobal'

const state = {
  extOrg: {},
  prfgrpExtOrg: {}
}

// getters
const getters = {
  extOrg: state => state.extOrg,
  prfgrpExtOrg: state => state.prfgrpExtOrg,
  deleteVisible: state => state.deleteVisible
}

// actions
const actions = {
    getTexten: async ({ dispatch }) => {
    let textIDs = [17, 23, 149, 4891, 4892, 8756, 8757, 12980]
    dispatch('gettranslations', textIDs, { root: true })
  },
  getExtOrgDetails: async ({ commit }) => {
    // haal data op voor de pagina
    const data = await util.getDataApi('allroles/PEapi_SPE650_BH_ExtOrgDetails')
    commit('setExtOrgDetails', data)
    commit('stopLoading', null, { root: true })
  },
  deleteExtOrgDetails: async () => {
    // voer delete uit en ga naar de login pagina toe als delete gelukt is
    await util.getDataApi('allroles/PEapi_SPE650_BH_DeleteExtOrgDetails')
    window.location = `/login?css=${util.UgetCookie('pe_activeProfGroup')}&langID=${util.UgetCookie('pe_IntTaal')}`
  },
  saveExtOrgDetails: async ({ state, rootState, rootGetters, commit }, infoRequiredName) => {
    await util.getDataApi('allroles/PEapi_SPE650_BH_SaveExtOrgDetails', {
      ...state.extOrg,
      ...rootGetters['Metafields/GetSaveMetaData']({ infoRequiredName }),
      parameters: []
    })
    commit(
      'addNotification',
      {
        groupname: 'primary',
        message: rootState.translation[149]
      },
      { root: true }
    )
  }
}

// mutations
const mutations = {
  setExtOrgDetails(state, data) {
    state.extOrg = data.ds.data0[0]
    state.prfgrpExtOrg = data.ds.data1[0]
    state.deleteVisible = data.ds.data2[0].deleteVisible
    EventBus.$emit('updateloading', 0, false)
  },
  SET_EXT_ORG(state, value) {
    state.extOrg = value
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
